import {
  WEB_COMPONENT_ATTACK_SURFACE_REDUCTION_POTENTIAL,
  WEB_COMPONENT_EASM_ASN_MAP,
  WEB_COMPONENT_EASM_CERTIFICATE_EXPIRATION,
  WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY,
  WEB_COMPONENT_EASM_ASSETS_INVENTORY,
  WEB_COMPONENT_EASM_DNS_RECORDS,
  WEB_COMPONENT_EASM_PERIODIC_ASSETS,
  WEB_COMPONENT_EASM_PERIODIC_VULNERABILITIES,
  WEB_COMPONENT_EASM_RECENT_ASSETS,
  WEB_COMPONENT_EASM_SCHEDULE_CONTROLLER,
  WEB_COMPONENT_EASM_SERVICES_PER_PROTOCOL,
  WEB_COMPONENT_EASM_TOP_OPEN_PORTS,
  WEB_COMPONENT_EASM_TOP_VULNERABILITIES,
  WEB_COMPONENT_EASM_VULNERABLE_SERVERS,
  WEB_COMPONENT_EASM_VULNERABLE_SERVICES,
  WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ENCRYPTION,
  WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ISSUES,
  WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_MODULE_STATUS,
  WEB_COMPONENT_HEALTH_DASHBOARD_INVENTORY,
  WEB_COMPONENT_HEALTH_DASHBOARD_LICENSES,
  WEB_COMPONENT_HEALTH_DASHBOARD_MAC_OS_PERMISSIONS,
  WEB_COMPONENT_HEALTH_DASHBOARD_OVERVIEW,
  WEB_COMPONENT_HEALTH_DASHBOARD_PATCH_MANAGEMENT,
  WEB_COMPONENT_HEALTH_DASHBOARD_POLICIES,
  WEB_COMPONENT_HEALTH_DASHBOARD_PRODUCT_UPDATE,
  WEB_COMPONENT_HEALTH_DASHBOARD_SECURITY_SERVER_STATUS,
  WEB_COMPONENT_HEALTH_DASHBOARD_SIGNATURE_UPDATE,
  WEB_COMPONENT_HEALTH_DASHBOARD_UPDATE_STATUS,
  WEB_COMPONENT_PHASR_DETECTED_INCIDENTS,
  WEB_COMPONENT_PHASR_TOP_RECOMMENDATIONS,
  WEB_COMPONENT_PHASR_TAMPERING_TOOLS,
  WEB_COMPONENT_PHASR_MINERS,
  WEB_COMPONENT_PHASR_HACKTOOLS,
  WEB_COMPONENT_PHASR_REMOTE_ADMIN_TOOLS,
  WEB_COMPONENT_PHASR_OFF_LAND_BINARIES,

  // Risk Management
  WEB_COMPONENT_GZ_RM_COMPANY_STATE_WIDGET,
  WEB_COMPONENT_GZ_RM_SCORE_OVER_TIME_WIDGET,
  WEB_COMPONENT_GZ_RM_RESOURCES_BY_OS_WIDGET,
  WEB_COMPONENT_GZ_RM_SCANNED_RESOURCES_WIDGET,
  WEB_COMPONENT_GZ_RM_SCANNED_IDENTITIES_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_FINDINGS_SEVERITY_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_SEVERITY_WIDGET,
  WEB_COMPONENT_GM_RM_TOP_IDENTITY_RISKS_SEVERITY_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_FINDINGS_IMPACT_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_IMPACT_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_IDENTITY_RISK_IMPACT_WIDGET,
  WEB_COMPONENT_GZ_RM_VULNERABILITIES_BREAKDOWN_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_RESOURCES_RISK_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_IDENTITIES_RISK_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_INCIDENTS_WIDGET,
  WEB_COMPONENT_GZ_RM_TOP_RESOURCES_INCIDENTS_WIDGET,
  WEB_COMPONENT_GZ_RM_CVES_SEVERITY_WIDGET,
  WEB_COMPONENT_GZ_RM_APPLICATIONS_SEVERITY_WIDGET,
  WEB_COMPONENT_GZ_RM_OLDEST_VULNERABILITIES_WIDGET,
  WEB_COMPONENT_GZ_RM_ZERO_TRUST_WIDGET,
} from '../../webcomponents.constants';
import { translateFn } from '../../utils/translator.helper';

export function getTranslatedWidgetTitle(widgetId: string): string {
  switch (widgetId) {
    //HEALTH
    case WEB_COMPONENT_HEALTH_DASHBOARD_UPDATE_STATUS:
      return translateFn('Endpoint update status');
    case WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ISSUES:
      return translateFn('Endpoint issues');
    case WEB_COMPONENT_HEALTH_DASHBOARD_POLICIES:
      return translateFn('Endpoint policy status');
    case WEB_COMPONENT_HEALTH_DASHBOARD_LICENSES:
      return translateFn('License');
    case WEB_COMPONENT_HEALTH_DASHBOARD_MAC_OS_PERMISSIONS:
      return translateFn('Permission issues on macOS');
    case WEB_COMPONENT_HEALTH_DASHBOARD_PATCH_MANAGEMENT:
      return translateFn('Endpoint patch management');
    case WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_MODULE_STATUS:
      return translateFn('Endpoint modules status');
    case WEB_COMPONENT_HEALTH_DASHBOARD_SECURITY_SERVER_STATUS:
      return translateFn('Security Server status');
    case WEB_COMPONENT_HEALTH_DASHBOARD_INVENTORY:
      return translateFn('Inventory');
    case WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ENCRYPTION:
      return translateFn('Endpoint encryption status');
    case WEB_COMPONENT_HEALTH_DASHBOARD_OVERVIEW:
      return translateFn('Endpoints overview');
    case WEB_COMPONENT_HEALTH_DASHBOARD_PRODUCT_UPDATE:
      return translateFn('Product update status');
    case WEB_COMPONENT_HEALTH_DASHBOARD_SIGNATURE_UPDATE:
      return translateFn('Security content update status');
    //EASM
    case WEB_COMPONENT_EASM_SCHEDULE_CONTROLLER:
      return translateFn('Scan configuration');
    case WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY:
      return translateFn('Artifacts');
    case WEB_COMPONENT_EASM_ASSETS_INVENTORY:
      return translateFn('Total number of assets');
    case WEB_COMPONENT_EASM_RECENT_ASSETS:
      return translateFn('Assets recently sent to scan');
    case WEB_COMPONENT_EASM_PERIODIC_ASSETS:
      return translateFn('Discovered assets per week');
    case WEB_COMPONENT_EASM_PERIODIC_VULNERABILITIES:
      return translateFn('Discovered vulnerabilities per week');
    case WEB_COMPONENT_EASM_ASN_MAP:
      return translateFn('ASN reports');
    case WEB_COMPONENT_EASM_VULNERABLE_SERVERS:
      return translateFn('Name servers vulnerable to zone transfers');
    case WEB_COMPONENT_EASM_DNS_RECORDS:
      return translateFn('DNS records');
    case WEB_COMPONENT_EASM_VULNERABLE_SERVICES:
      return translateFn('Top vulnerable services');
    case WEB_COMPONENT_EASM_SERVICES_PER_PROTOCOL:
      return translateFn('Top services per protocol');
    case WEB_COMPONENT_EASM_CERTIFICATE_EXPIRATION:
      return translateFn('Certificate expiration');
    case WEB_COMPONENT_EASM_TOP_VULNERABILITIES:
      return translateFn('Top critical vulnerabilities');
    case WEB_COMPONENT_EASM_TOP_OPEN_PORTS:
      return translateFn('Top open ports');
    // PHASR
    case WEB_COMPONENT_ATTACK_SURFACE_REDUCTION_POTENTIAL:
      return translateFn('Attack surface exposure');
    case WEB_COMPONENT_PHASR_DETECTED_INCIDENTS:
      return translateFn('Detected incidents for monitored attack vectors categories');
    case WEB_COMPONENT_PHASR_TOP_RECOMMENDATIONS:
      return translateFn('Top recommendations by impact');
    case WEB_COMPONENT_PHASR_TAMPERING_TOOLS:
      return translateFn('Tampering tools');
    case WEB_COMPONENT_PHASR_MINERS:
      return translateFn('Crypto miners');
    case WEB_COMPONENT_PHASR_HACKTOOLS:
      return translateFn('Piracy tools');
    case WEB_COMPONENT_PHASR_REMOTE_ADMIN_TOOLS:
      return translateFn('Remote admin tools');
    case WEB_COMPONENT_PHASR_OFF_LAND_BINARIES:
      return translateFn('Living off the land binaries');
    case WEB_COMPONENT_GZ_RM_COMPANY_STATE_WIDGET:
      return translateFn('Company state');
    case WEB_COMPONENT_GZ_RM_SCORE_OVER_TIME_WIDGET:
      return translateFn('Score over time');
    case WEB_COMPONENT_GZ_RM_RESOURCES_BY_OS_WIDGET:
      return translateFn('Resources by OS');
    case WEB_COMPONENT_GZ_RM_SCANNED_RESOURCES_WIDGET:
      return translateFn('Scanned resources');
    case WEB_COMPONENT_GZ_RM_SCANNED_IDENTITIES_WIDGET:
      return translateFn('Scanned identities');
    case WEB_COMPONENT_GZ_RM_TOP_FINDINGS_SEVERITY_WIDGET:
      return translateFn('Top findings by severity');
    case WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_SEVERITY_WIDGET:
      return translateFn('Top vulnerabilities by severity');
    case WEB_COMPONENT_GM_RM_TOP_IDENTITY_RISKS_SEVERITY_WIDGET:
      return translateFn('Top identity risks by severity');
    case WEB_COMPONENT_GZ_RM_TOP_FINDINGS_IMPACT_WIDGET:
      return translateFn('Top findings by impact');
    case WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_IMPACT_WIDGET:
      return translateFn('Top vulnerabilities by impact');
    case WEB_COMPONENT_GZ_RM_TOP_IDENTITY_RISK_IMPACT_WIDGET:
      return translateFn('Top identity risks by impact');
    case WEB_COMPONENT_GZ_RM_VULNERABILITIES_BREAKDOWN_WIDGET:
      return translateFn('Vulnerabilities breakdown');
    case WEB_COMPONENT_GZ_RM_TOP_RESOURCES_RISK_WIDGET:
      return translateFn('Top resources at risk');
    case WEB_COMPONENT_GZ_RM_TOP_IDENTITIES_RISK_WIDGET:
      return translateFn('Top identities at risk');
    case WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_INCIDENTS_WIDGET:
      return translateFn('Top vulnerabilities involved in incidents');
    case WEB_COMPONENT_GZ_RM_TOP_RESOURCES_INCIDENTS_WIDGET:
      return translateFn('Top resources involved in incidents');
    case WEB_COMPONENT_GZ_RM_CVES_SEVERITY_WIDGET:
      return translateFn('Vulnerabilities by severity');
    case WEB_COMPONENT_GZ_RM_APPLICATIONS_SEVERITY_WIDGET:
      return translateFn('Vulnerabilities by application');
    case WEB_COMPONENT_GZ_RM_OLDEST_VULNERABILITIES_WIDGET:
      return translateFn('Oldest vulnerable applications');
    case WEB_COMPONENT_GZ_RM_ZERO_TRUST_WIDGET:
      return translateFn('Zero trust');
    default:
      return 'Unknown widget';
  }
}
